import React from 'react';
import { OrderEntryMobileCardFieldsSheetProps } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/components/order-entry-mobile-card-fields-sheet-types';

/** Intended only for phones; the web wrapper never renders the mobile screen, so this keeps the native drag list out of the web bundle. */
export const OrderEntryMobileCardFieldsSheet: React.FC<
  OrderEntryMobileCardFieldsSheetProps
> = () => null;
